import { cva } from '@/styled-system/css';

export const tableCellRecipe = cva({
  base: {},
  variants: {
    interactive: {
      true: {
        cursor: 'pointer',
        userSelect: 'none',
      },
      false: {},
    },
    selected: {
      true: {
        backgroundColor: 'Table.Cell.bg.selected',
        color: 'text.neutral',
      },
      false: {},
    },
  },
});
